<template>
    <div class="Power_execl">
        <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点选择'"> -->
        <div class="tree-wrap">
            <div style="margin-bottom: 1.2rem;flex: 1">
                <!-- <el-radio-group
                    v-model="selectType"
                    v-for="item in points"
                    :key="item.tree_unit_type_id"
                    @change="toggleTab(item.tree_unit_type_id)"
                    class="leader-style-radio"
                    size="middle"
                >
                    <el-radio-button :label="item.type_name"></el-radio-button>
                </el-radio-group> -->
                <el-form class="leader-style-form" label-width="50px">
                    <el-form-item label="类型">
                        <el-select v-model="selectType" @change="toggleTab">
                            <el-option
                                v-for="item in points"
                                :key="item.tree_unit_type_id"
                                :label="item.type_name"
                                :value="item.tree_unit_type_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 
                :defaultExpandedKeys="defaultCheckKeys" -->
            <me-tree
                ref="myTree"
                :treeData="data"
                :treeLoading="treeLoading"
                :treeToolBar="false"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :showCheckbox="true"
                :title="treeTitle"
                :cascadingVar="true"
                :checkStrictly.sync="checkStrictly"
                :isCheckClick="true"
                :defaultCheckKeys="defaultCheckKeys"
                @handleCheckBoxClick="handleTreeNodeClick"
            ></me-tree>
        </div>
        <!-- </me-collapes> -->

        <div
            class="content is-alway-shadow leader-tab"
            :style="{ width: width }"
        >
            <el-tabs v-model="tabVal" type="card" @tab-click="handleTabClick">
                <el-tab-pane label="年报" name="year"></el-tab-pane>
                <el-tab-pane label="月报" name="month"></el-tab-pane>
                <el-tab-pane label="日报" name="day"></el-tab-pane>
                <el-tab-pane label="自定义" name="custom"></el-tab-pane>
            </el-tabs>
            <div class="search_cont">
                <el-form
                    label-width="60px"
                    :inline="true"
                    :model="searchForm"
                    class="form leader-style-form"
                >
                    <el-form-item label="时间">
                        <el-date-picker
                            v-model="time"
                            align="right"
                            type="date"
                            :clearable="false"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'day'"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="time"
                            type="month"
                            :clearable="false"
                            placeholder="选择月"
                            value-format="yyyy-MM"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'month'"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="time"
                            type="year"
                            placeholder="选择年"
                            format="yyyy"
                            value-format="yyyy"
                            :clearable="false"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'year'"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="start_show_day"
                            align="right"
                            type="date"
                            :clearable="false"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'custom'"
                        ></el-date-picker>
                        <span style="color: #fff" v-show="tabVal === 'custom'"
                            >&nbsp;&nbsp;至&nbsp;&nbsp;</span
                        >
                        <el-date-picker
                            v-model="end_show_day"
                            align="right"
                            type="date"
                            :clearable="false"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'custom'"
                        ></el-date-picker>
                        <template v-if="tabVal != 'custom'">
                            <div class="button-group">
                                <el-button
                                    class="leader-common-button"
                                    @click="forwardTimeClick"
                                    size="medium"
                                >
                                    上一{{
                                        tabVal === "day"
                                            ? "日"
                                            : tabVal === "month"
                                            ? "月"
                                            : "年"
                                    }}
                                </el-button>
                                <el-button
                                    class="leader-common-button"
                                    :disabled="nextTimeDisabled"
                                    @click="nextTimeClick"
                                    size="medium"
                                >
                                    下一{{
                                        tabVal === "day"
                                            ? "日"
                                            : tabVal === "month"
                                            ? "月"
                                            : "年"
                                    }}
                                </el-button>
                            </div>
                        </template>
                    </el-form-item>

                    <div style="margin-right:10px;">
                        <el-button
                            class="leader-common-button"
                            size="medium"
                            @click="handleSearchReport"
                            >查询</el-button
                        >
                        <el-button
                            class="leader-common-button"
                            size="medium"
                            @click="handleExport"
                            >导出</el-button
                        >
                    </div>
                </el-form>
            </div>
            <div class="table_cont-wrap">
                <div class="title">
                    <div class="green"></div>
                    {{
                        tabVal === "day"
                            ? "日报(单位:" + pointClassObj.class_unit + ")"
                            : tabVal === "month"
                            ? "月报(单位:" + pointClassObj.class_unit + ")"
                            : tabVal === "year"
                            ? "年报(单位:" + pointClassObj.class_unit + ")"
                            : "自定义(单位:" + pointClassObj.class_unit + ")"
                    }}
                </div>
                <div class="table-wrap">
                    <el-scrollbar style="height: 90%; width: 100%;box-sizing: border-box;">
                       <div style="overflow: visible;">
                           <template v-if="tabVal == 'custom'">
                               <el-table
                                   border
                                   class="leader-style-table"
                                   :data="customDatas"
                                   style="background: #0f1e3c;width: 100%;"
                               >
                                   <el-table-column
                                       align="center"
                                       label="序号"
                                       width="50"
                                   >
                                       <template slot-scope="scope">
                                           <span>{{ scope.$index + 1 }}</span>
                                       </template>
                                   </el-table-column>
                                   <el-table-column
                                       align="center"
                                       label="名称"
                                       width="300"
                                       property="point_name"
                                   ></el-table-column>
                                   <el-table-column
                                       v-for="(item, index) in customHeaders"
                                       :key="item.head_date"
                                       align="center"
                                       :label="item.head_date"
                                       width="150"
                                       :property="item.head_power"
                                   >
                                   </el-table-column>
                               </el-table>
                           </template>
                           <template v-else>
                               <div
                                   class="table-header"
                                   style="position: relative;"
                               >
                                   <!-- <div class="table-header-colum">序号</div> -->
                                   <div
                                       class="table-header-colum table-name header-fixed"
                                   >
                                       名称
                                   </div>
                                   <!-- <div style="position: absolute; top:0; left: 200px"> -->
                                   <template v-if="tabVal === 'day'">
                                       <div
                                           class="table-header-colum"
                                           v-for="(item, index) in tableData.hours"
                                           :key="index"
                                       >
                                           {{ index < 9 ? "0" + index : index }}时
                                       </div>
                                   </template>
                                   <template v-if="tabVal === 'month'">
                                       <div
                                           class="table-header-colum"
                                           v-for="(item, index) in tableData.days"
                                           :key="index"
                                       >
                                           {{ index + 1 }}日
                                       </div>
                                   </template>
                                   <template v-if="tabVal === 'year'">
                                       <div
                                           class="table-header-colum"
                                           v-for="(item,
                                        index) in tableData.months"
                                           :key="index"
                                       >
                                           {{ index + 1 }}月
                                       </div>
                                   </template>
                                   <div class="table-header-colum">合计</div>
                                   <!-- </div> -->
                               </div>
                               <template v-if="tableData.list">
                                   <div
                                       class="table-row"
                                       v-for="(item, index) in tableData.list"
                                       :key="index"
                                   >
                                       <!-- <div class="table-row-item">{{ index + 1 }}</div> -->
                                       <div class="table-row-item table-name header-fixed">
                                           {{ item.point_name }}
                                       </div>
                                       <template v-if="tabVal === 'day'">
                                           <div
                                               class="table-row-item"
                                               v-for="(item,
                                            indexList) in tableData.hours"
                                               :key="item"
                                           >
                                               {{
                                                   tableData.list[index][
                                                   "is_" + (indexList + 1)
                                                       ]
                                               }}
                                           </div>
                                       </template>
                                       <template v-if="tabVal === 'month'">
                                           <div
                                               class="table-row-item"
                                               v-for="(item,
                                            indexMList) in tableData.days"
                                               :key="item"
                                           >
                                               {{
                                                   tableData.list[index][
                                                   "is_" + (indexMList + 1)
                                                       ]
                                               }}
                                           </div>
                                       </template>
                                       <template v-if="tabVal === 'year'">
                                           <div
                                               class="table-row-item"
                                               v-for="(item,
                                            indexYList) in tableData.months"
                                               :key="item"
                                           >
                                               {{
                                                   tableData.list[index][
                                                   "is_" + (indexYList + 1)
                                                       ]
                                               }}
                                           </div>
                                       </template>
                                       <div class="table-row-item">
                                           {{ item.total }}
                                       </div>
                                   </div>
                                   <div class="table-row">
                                       <!-- <div class="table-row-item"></div> -->
                                       <div
                                           class="table-row-item table-name header-fixed"
                                       >
                                           合计
                                       </div>
                                       <template v-if="tabVal === 'day'">
                                           <div
                                               class="table-row-item"
                                               v-for="(item,
                                            indexList) in tableData.hours"
                                               :key="item"
                                           >
                                               {{
                                                   tableData[
                                                   "total_" + (indexList + 1)
                                                       ] | floatFormat
                                               }}
                                           </div>
                                       </template>
                                       <template v-if="tabVal === 'month'">
                                           <div
                                               class="table-row-item"
                                               v-for="(item,
                                            indexMList) in tableData.days"
                                               :key="item"
                                           >
                                               {{
                                                   tableData[
                                                   "total_" + (indexMList + 1)
                                                       ] | floatFormat
                                               }}
                                           </div>
                                       </template>
                                       <template v-if="tabVal === 'year'">
                                           <div
                                               class="table-row-item"
                                               v-for="(item,
                                            indexYList) in tableData.months"
                                               :key="item"
                                           >
                                               {{
                                                   tableData[
                                                   "total_" + (indexYList + 1)
                                                       ] | floatFormat
                                               }}
                                           </div>
                                       </template>
                                       <div class="table-row-item">
                                           {{ tableData.total_all | floatFormat }}
                                       </div>
                                   </div>
                               </template>
                               <div v-else class="table-nodata">暂无数据</div>
                           </template>
                       </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import moment from "moment";
import * as api from "@/http/energy_excel.js";
import {
    getCommonPointList,
    getPointClassList
} from "@/http/Use_electricity_monitor.js";
// import {
//     getSysDate,
//     getTreeUnitTypeTypeList,
//     getTreeUnitListTypes,
// } from "@/http/api.js";
import * as _api from "@/http/api.js";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    filters: {
        // 2. 局部过滤器
        floatFormat(value) {
            return parseInt(value * 100) / 100;
        }
    },
    data() {
        return {
            point_class_id: "", //判断当前页面是水/电/气/。。。
            pointClassObj: { class_unit: "" }, //文字、单位等
            tabVal: "year",
            time: "",
            start_show_day: "",
            end_show_day: "",
            treeTitle: "采集点选择",
            selectType: "采集点",
            selectTypeId: "0",
            points: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            nextTimeDisabled: false,
            todayY: "",
            todayM: "",
            todayD: "",
            data: [],
            customHeaders: [],
            customDatas: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            nodeKey: "point_id",
            tableData: {},
            tableLoading: false,
            systemDate: {},
            width: "calc(100% - 340px)"
        };
    },
    created() {},
    mounted() {},
    watch: {
        $route: {
            handler: function(val, oldVal) {
                this.point_class_id = val.params.type;
                this.tableData = {};
                this.selectTypeId = "0";
                this.selectType = "采集点";
                this.getSysDate("day");
                this.getTreeUnitTypeList();
                this.todayY = this.getTimeValue("year");
                this.todayM = this.getTimeValue("month");
                this.todayD = this.getTimeValue("day");
                this.nextTimeDisabled = true;
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            _api.getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.systemDate = res.bus_json;
                    this.time = res.bus_json.sysdate4;
                    getPointClassList({
                        point_class_id: this.point_class_id
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.pointClassObj = res.bus_json;
                            this.getCommonPointList();
                        }
                    });
                }
            });
        },
        // 获取部门 区域
        getTreeUnitTypeList() {
            _api.getTreeUnitTypeTypeList({
                point_class_id: this.point_class_id
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.points = [
                        {
                            tree_unit_type_id: "0", // 采集点
                            type_name: "采集点"
                        }
                    ];
                    if (res.bus_json.length > 0) {
                        this.points.push(...res.bus_json);
                    }
                }
            });
        },
        toggleTab(type) {
            this.selectTypeId = type;
            if (type == "0") {
                this.treeTitle = "采集点选择";
                this.getCommonPointList();
            } else {
                if (type == "10") {
                    this.treeTitle = "区域选择";
                } else {
                    this.treeTitle = "部门选择";
                }
                this.getTreeUnitListTypes(type);
            }
        },
        /**
         * 获取采集点信息
         */
        getCommonPointList() {
            this.treeLoading = true;
            getCommonPointList({ point_class_id: this.point_class_id }).then(
                res => {
                    if (res && res.error_code === "0") {
                        this.data = res.bus_json;
                        let formatData = this.tickMenuIdFilter().filter(
                            res.bus_json
                        );
                        this.defaultCheckKeys = formatData.firstPoint.point_id
                            ? [formatData.firstPoint.point_id]
                            : [];
                        // this.getYearData();
                        if (this.tabVal == "year") {
                            this.getYearData();
                        } else if (this.tabVal == "month") {
                            this.getMonthData();
                        } else if (this.tabVal == "day") {
                            this.getDayData();
                        } else {
                            this.getCustomData();
                        }
                    }
                    this.treeLoading = false;
                }
            );
        },
        // 获取部门区域
        getTreeUnitListTypes(tree_unit_type_id) {
            _api.getTreeUnitListTypes({
                point_class_id: this.point_class_id,
                tree_unit_type_id
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.data = res.bus_json;
                    this.transFormerData(this.data);
                    // this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    this.defaultCheckKeys = [this.data[0].point_id];

                    if (this.tabVal == "year") {
                        this.getTreeYearData();
                    } else if (this.tabVal == "month") {
                        this.getTreeMonthData();
                    } else if (this.tabVal == "day") {
                        this.getTreeDayData();
                    } else {
                        this.getTreeCustomData();
                    }
                }
            });
        },
        transFormerData(datas) {
            datas.forEach(item => {
                item["point_id"] = item.tree_unit_id;
                item["point_name"] = item.tree_unit_name;
                if (item.childList && item.childList.length > 0) {
                    this.transFormerData(item.childList);
                }
            });
        },
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function(obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (!obj.collector_id) {
                    //实采集点
                    obj.disabled = false;
                    resultArr.push(obj.point_id);
                } else {
                    obj.disabled = false;
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function(arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            // this.defaultExpandedKeys = [select.point_id];
        },
        /**
         * 日期改变回调函数
         */
        handleTimeChange(val) {
            let toDay = new Date(this.toDay).getTime();
            let selectTime = new Date(val).getTime();
            if (selectTime >= toDay) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        /**
         * 日月年tab切换回调事件
         */
        handleTabClick(tab, event) {
            this.nextTimeDisabled = true;
            if (tab.name === "day") {
                this.time = this.systemDate.sysdate;
                // this.getDayData();
                if (this.selectTypeId == "0") {
                    this.getDayData();
                } else {
                    this.getTreeDayData();
                }
            } else if (tab.name === "month") {
                this.time = this.systemDate.sysdate3;
                // this.getMonthData();
                if (this.selectTypeId == "0") {
                    this.getMonthData();
                } else {
                    this.getTreeMonthData();
                }
            } else if (tab.name === "year") {
                this.time = this.systemDate.sysdate4;
                // this.getYearData();
                if (this.selectTypeId == "0") {
                    this.getYearData();
                } else {
                    this.getTreeYearData();
                }
            } else {
                this.start_show_day = moment(new Date(this.systemDate.sysdate))
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
                this.end_show_day = moment(new Date(this.systemDate.sysdate))
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
                if (this.selectTypeId == "0") {
                    this.getCustomData();
                } else {
                    this.getTreeCustomData();
                }
            }
        },
        /**
         * 获取时间值
         * params{type<string>} type = day(日) type = month(月) type = year(年)
         */
        getTimeValue(type) {
            let date = new Date();
            if (type === "year") {
                return date.getFullYear() + "";
            } else if (type === "month") {
                return date.getFullYear() + "-" + (date.getMonth() + 1);
            } else {
                return (
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate()
                );
            }
        },
        /**
         * 下一日、下一月、下一年点击
         */

        nextTimeClick() {
            let todayD = new Date(this.todayD).getTime();
            let todayM = new Date(this.todayM).getTime();
            let todayY = new Date(this.todayY).getTime();
            if (this.tabVal === "day") {
                this.time = moment(new Date(this.time))
                    .add(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = moment(new Date(this.time))
                    .add(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = moment(new Date(this.time))
                    .add(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
            let selectTime = new Date(this.time).getTime();
            if (
                (this.tabVal === "day" && selectTime >= todayD) ||
                (this.tabVal === "month" && selectTime >= todayM) ||
                (this.tabVal === "year" && selectTime >= todayY)
            ) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        /**
         * 上一日、上一月、上一年点击
         */
        forwardTimeClick() {
            this.nextTimeDisabled = false;
            if (this.tabVal === "day") {
                this.time = moment(new Date(this.time))
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = moment(new Date(this.time))
                    .subtract(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = moment(new Date(this.time))
                    .subtract(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
        },
        /**
         * 获取日报列表
         */
        getTreeDayData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            params = {
                tree_unit_ids: point_ids,
                show_day: this.time,
                point_class_id: this.point_class_id
            };
            this.tableLoading = true;
            _api.getDayData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取月报列表
         */
        getTreeMonthData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            this.tableLoading = true;
            params = {
                tree_unit_ids: point_ids,
                show_month: this.time,
                point_class_id: this.point_class_id
            };
            _api.getMonthData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取年报列表
         */
        getTreeYearData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            this.tableLoading = true;
            params = {
                tree_unit_ids: point_ids,
                show_year: this.time,
                point_class_id: this.point_class_id
            };
            _api.getYearData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取日报列表
         */
        getDayData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }

            let point_ids = this.defaultCheckKeys.join(",");
            params = {
                point_ids: point_ids,
                show_day: this.time,
                point_class_id: this.point_class_id
            };
            this.tableLoading = true;
            api.getDayData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取月报列表
         */
        getMonthData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                show_month: this.time,
                point_class_id: this.point_class_id
            };
            api.getMonthData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取年报列表
         */
        getYearData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                show_year: this.time,
                point_class_id: this.point_class_id
            };
            api.getYearData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        // 获取自定义
        getCustomData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            const start = moment(this.start_show_day, "YYYY-MM-DD");
            const end = moment(this.end_show_day, "YYYY-MM-DD");
            const a = end.diff(start, "days");
            if (parseInt(a) < 0) {
                this.$message({
                    message: "结束时间不能小于开始时间",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                start_show_day: this.start_show_day,
                end_show_day: this.end_show_day,
                point_class_id: this.point_class_id
            };
            _api.getMonthData2(params).then(res => {
                if (res) {
                    // this.tableData = res.bus_json;
                    this.customHeaders = res.bus_json.headList;
                    this.customDatas = res.bus_json.returnList;
                }
                this.tableLoading = false;
                this.$forceUpdate();
            });
        },
        getTreeCustomData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            const start = moment(this.start_show_day, "YYYY-MM-DD");
            const end = moment(this.end_show_day, "YYYY-MM-DD");
            const a = end.diff(start, "days");
            if (parseInt(a) < 0) {
                this.$message({
                    message: "结束时间不能小于开始时间",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            this.tableLoading = true;
            params = {
                tree_unit_ids: point_ids,
                start_show_day: this.start_show_day,
                end_show_day: this.end_show_day,
                point_class_id: this.point_class_id
            };
            _api.getMonthData2(params).then(res => {
                if (res) {
                    // this.tableData = res.bus_json;
                    this.customHeaders = res.bus_json.headList;
                    this.customDatas = res.bus_json.returnList;
                }
                this.tableLoading = false;
                this.$forceUpdate();
            });
        },
        /**
         * 选择搜索
         */
        handleSearchReport() {
            if (this.tabVal === "day") {
                if (this.selectTypeId == "0") {
                    this.getDayData();
                } else {
                    this.getTreeDayData();
                }
            } else if (this.tabVal === "month") {
                if (this.selectTypeId == "0") {
                    this.getMonthData();
                } else {
                    this.getTreeMonthData();
                }
            } else if (this.tabVal === "year") {
                if (this.selectTypeId == "0") {
                    this.getYearData();
                } else {
                    this.getTreeYearData();
                }
            } else {
                if (this.selectTypeId == "0") {
                    this.getCustomData();
                } else {
                    this.getTreeCustomData();
                }
            }
        },
        handleExport() {
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            if (this.selectTypeId == "0") {
                if (this.tabVal == "custom") {
                    this.handleExportExlCustom();
                } else {
                    this.handleExportExl();
                }
            } else {
                if (this.tabVal == "custom") {
                    this.handleUnitExportExlCustom();
                } else {
                    this.handleUnitExportExl();
                }
            }
        },
        /**
         * 导出excel表格
         */
        handleExportExl() {
            let point_ids = this.defaultCheckKeys.join(",") + ",";
            let show_type =
                this.tabVal === "day"
                    ? "1"
                    : this.tabVal === "month"
                    ? "2"
                    : "3";
            api.getExcel({
                show_time: this.time,
                point_ids: point_ids,
                show_type: show_type,
                point_class_id: this.point_class_id
            }).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        this.tabVal === "day"
                            ? this.time + "日报" + ".xlsx"
                            : this.tabVal === "month"
                            ? this.time + "月报" + ".xlsx"
                            : this.time + "年报" + ".xlsx";
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
                // loading.close();
            });
        },
        handleExportExlCustom() {
            const start = moment(this.start_show_day, "YYYY-MM-DD");
            const end = moment(this.end_show_day, "YYYY-MM-DD");
            let days = end.diff(start, "seconds") / 60 / 60 / 24;
            console.log("days: ", days);
            if (parseInt(days) >= 60) {
                this.$message({
                    message: "间隔时间不能超过60天",
                    type: "warning"
                });
                return;
            }
            const a = end.diff(start, "days");
            if (parseInt(a) < 0) {
                this.$message({
                    message: "结束时间不能小于开始时间",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            _api.getExcelCustom({
                start_show_day: this.start_show_day,
                end_show_day: this.end_show_day,
                point_ids: point_ids,
                point_class_id: this.point_class_id
            }).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        this.start_show_day +
                        "-" +
                        this.end_show_day +
                        "报表" +
                        ".xlsx";
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
            });
        },
        /**
         * 导出excel表格
         */
        handleUnitExportExl() {
            let point_ids = this.defaultCheckKeys.join(",");
            let show_type =
                this.tabVal === "day"
                    ? "1"
                    : this.tabVal === "month"
                    ? "2"
                    : "3";
            _api.getExcel({
                show_time: this.time,
                tree_unit_ids: point_ids,
                show_type: show_type
            }).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        this.tabVal === "day"
                            ? this.time + "日报" + ".xlsx"
                            : this.tabVal === "month"
                            ? this.time + "月报" + ".xlsx"
                            : this.time + "年报" + ".xlsx";
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
            });
        },
        handleUnitExportExlCustom() {
            const start = moment(this.start_show_day, "YYYY-MM-DD");
            const end = moment(this.end_show_day, "YYYY-MM-DD");
            let days = end.diff(start, "seconds") / 60 / 60 / 24;
            console.log("days: ", days);
            if (parseInt(days) >= 60) {
                this.$message({
                    message: "间隔时间不能超过60天",
                    type: "warning"
                });
                return;
            }
            const a = end.diff(start, "days");
            if (parseInt(a) < 0) {
                this.$message({
                    message: "结束时间不能小于开始时间",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            _api.getExcelCustom({
                start_show_day: this.start_show_day,
                end_show_day: this.end_show_day,
                tree_unit_ids: point_ids
            }).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        this.start_show_day +
                        "-" +
                        this.end_show_day +
                        "报表" +
                        ".xlsx";
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
            });
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 340px)" : "calc(100% - 56px)";
        }
    }
};
</script>
<style lang="scss">
.Power_execl {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .tree-wrap {
        z-index: 0;
        margin: 0 20px;
        width: px2Rem(280px);
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: px2Rem(5px);
    }
    .content {
        height: calc(98% - 5px);
        margin-top: 5px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        border-radius: px2Rem(5px);
        box-sizing: border-box;
        transition: width 500ms;
        .el-tabs--card {
            margin: 0;
        }
        .search_cont {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .form {
                width: 100%;
                display: flex;
                justify-content: space-between;
                .button-group {
                    display: inline-block;
                    margin-left: px2Rem(20px);
                    // button {
                    //     background: rgb(41, 184, 94);
                    //     color: white;
                    //     outline: none;
                    //     border-color: rgb(41, 184, 94);
                    // }
                    .el-button.is-disabled,
                    .el-button.is-disabled:focus,
                    .el-button.is-disabled:hover {
                        border-color: #ebeef5;
                    }
                }
                .el-input__inner {
                    height: px2Rem(36px);
                    line-height: px2Rem(36px);
                }
            }
        }
        .table_cont-wrap {
            width: 100%;
            // padding: 0 10px;
            box-sizing: border-box;
            overflow: hidden;
            .title {
                color: #fff;
                border-bottom: 1px solid #56fcff;
            }
            .green {
                height: px2Rem(12px);
                width: px2Rem(5px);
                background: #56fcff;
                margin: px2Rem(10px);
                float: left;
            }
            width: 100%;
            font-size: px2Rem(16px);
            text-align: left;
            line-height: px2Rem(32px);
        }
        .table-wrap {
            // min-width: 100%;
            width: 100%;
            box-sizing: border-box;
            //overflow: auto;
            overflow: visible;
            font-size: px2Rem(14px);
            height: px2Rem(600px);
            color: #fff;
            //border: 1px solid red;
            background: none;
            padding-left: 0 !important;
            padding-right: 0 !important;
            .header-fixed {
                //position: fixed;
                flex: 2 !important;
                background-color: #10344a !important;
                min-width: 15rem !important;
            }
            .table-header {
                overflow: visible;
            }
            .table-header-colum {
                background: #10344a !important;
            }
            .table-header-colum:nth-child(2) {
                //margin-left: px2Rem(200px);
            }
            .table-row {
                .table-row-item:nth-child(2) {
                   // margin-left: px2Rem(200px);
                }
            }
            .table-nodata {
                border: 1px solid #ebeef5;
                color: #fff;
            }
            .table-header {
                min-width: 100%;
                display: flex;
                flex-direction: row;
            }
            .table-name {
                width: px2Rem(200px) !important;
                box-sizing: border-box;
            }
            .table-header-colum {
                flex: 1;
                text-align: center;
                min-width: px2Rem(80px);
                padding: 3px 0;
            }
            .table-row:nth-child(2n) {
                color: #ffffff;
                .table-row-item {
                    background: transparent !important;
                }

                .table-name {
                    //background: #000 !important;
                }
            }

            .table-row:nth-child(2n + 1) {
                color: #ffffff;
                .table-row-item {
                    background: #10344a !important;
                }
            }
            .table-row {
                display: flex;
                flex-direction: row;
                min-width: 100%;
                .table-row-item {
                    flex: 1;
                    text-align: center;
                    min-width: px2Rem(80px);
                    padding: 3.5px 0;
                }
            }
            .table-nodata {
                text-align: center;
            }
        }
    }
}
</style>
